import React from 'react'
import BlogPost from './BlogPost'

export default function GoodDataFromPipeline() {
  return (
    <BlogPost
      translationKey="goodDataFromPipeline"
      seoTitle="좋은 데이터는 파이프라인에서 만들어진다 | Hyunjin Jae"
      seoDescription="데이터 품질은 파이프라인 전체의 흐름에서 결정된다는 생각을 담은 글입니다."
      seoKeywords="데이터 파이프라인, 데이터 품질, ETL, AI, data pipeline, data quality, machine learning"
      seoTags={['data pipeline', 'data quality', 'AI', 'technology']}
    />
  )
}
